import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Grid, IconButton } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

interface SortableItemProps {
    id: string; // Assuming the id is a string
    image: any; // Adjust this type based on your image object structure
    index: number;
    onRemove: () => void;
    paramId?:any;
}
export const SortableItem: React.FC<SortableItemProps> = ({ id, image, paramId, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
    console.log(image,'image');
  return (
    <Grid item xs={12} sm={6} md={4} ref={setNodeRef} style={style}>
      <div style={{ position: "relative" }}>
        <div
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
          }}
        >
          <img
            src={image.preview ? image.preview : image}
            alt="Preview"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "4px",
              objectFit: "cover",
            }}
          />
        </div>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            console.log("Remove clicked for:", id);
            onRemove();
          }}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 2,
          }}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    </Grid>
  );
};
